import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-159605d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" default header ")
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" default body ")
const _hoisted_8 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "header", {}, () => [
                _hoisted_5
              ], true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "body", {}, () => [
                _hoisted_7
              ], true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "footer-yes-button", {}, () => [
                _createElementVNode("button", {
                  class: "modal-default-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('yes')))
                }, " Yes! ")
              ], true),
              _renderSlot(_ctx.$slots, "footer-close-button", {}, () => [
                _createElementVNode("button", {
                  class: "modal-default-button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                }, " Close ")
              ], true)
            ])
          ])
        ])
      ])
    ]),
    _: 3
  }))
}